import * as React from "react";
import { optionalFormatIso8601DateTime } from "../../../../../../../../utils/format";
import { InfoField } from "./InfoField";

interface IProps {
    value?: string;
}

export const DateTimeInfoField = (props: IProps) => <InfoField value={props.value} formatter={optionalFormatIso8601DateTime}/>;
